/*
 * ****************************************************************************
 * Copyright (C) 2018-2018, All rights reserved.
 * Project: chessmate
 * Created On: March 23rd, 2018
 * Last Modified: March 23rd, 2018
 * ****************************************************************************
 */

import * as React from 'react';
import * as Mui from 'mui';
import { PageTitle } from '.';

const hideToolbars = true;

/** PageProps - Properties */
export interface PageProps extends React.HTMLProps<HTMLDivElement> {
  title?: string;
  loading?: boolean;
  toolbar?: React.ComponentType<any>;
}

/** Page */
export class Page extends React.Component<PageProps> {
  constructor(props: PageProps, ctx: any) {
    super(props, ctx);
  }

  render() {
    const copy: any = { ...this.props };
    delete copy.toolbar;
    delete copy.title;
    delete copy.loading;
    copy.className = `page ${copy.className || ''}`;
    return (
      <React.Fragment>
        {!!this.props.title && (<PageTitle>{this.props.title}</PageTitle>)}
        {this.renderToolbar('lg')}
        <Mui.Typography variant="body1" component="div" id="page" className="page" {...copy}>
          {this.renderToolbar('sm')}
          {this.props.loading
            ? (<div className="fill spinner"></div>)
            : this.props.children
          }
        </Mui.Typography>
      </React.Fragment>
    );
  }

  renderToolbar(size: 'lg' | 'sm') {
    const ToolbarControl = this.props.toolbar || (() => null);
    return (
      <Mui.AppBar className={'page-appbar page-appbar-' + size} position="static" color="inherit">
        <Mui.Toolbar className="page-toolbar">
          {!!this.props.title && (<Mui.Typography className="page-title" variant="title" color="inherit">{this.props.title}</Mui.Typography>)}
          <ToolbarControl />
        </Mui.Toolbar>
      </Mui.AppBar>
    );
  }
}

export default Page;


// WEBPACK FOOTER //
// ./src/components/page.tsx